"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coordinator_canister_ids = void 0;
exports.coordinator_canister_ids = process.env["COORDINATOR_CANISTER_IDS"] || ["r5m4o-xaaaa-aaaah-qbpfq-cai", "3vhcz-7yaaa-aaaah-qbr2q-cai"];
//# sourceMappingURL=constants.js.map